// extracted by mini-css-extract-plugin
module.exports = {"submission-evaluation-result-wrapper":"submission-evaluation-result-wrapper__iG7fx"};